import * as React from 'react';
import { withStyles, createStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import QuizQuestion from './QuizQuestion';
import SuccessDialog from '../Common/SuccessDialog';
import FailDialog from '../Common/FailDialog';
import PageTitle from '../Common/PageTitle';
import { getUserData } from '../../api/auth';

const jss = (theme: Theme) => createStyles({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    title: {
        width: '100%',
    },
    buttonContainer: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        marginTop: '15px',
    },
    pageNum: {
        display: 'flex',
        alignItems: 'center',
    },
});

interface Props {
    onSubmit: (quiz: any) => any;
    getQuiz: (id: string) => Promise<Bee.Quiz>;
    getParticipate: (params: Bee.Params) => any;
    match: {
        path: string;
        params: {
            [key: string]: string
        };
    };
    history: {
        push: (to: string) => void;
    };
    location: {
        hash: string;
    };
    classes: {
        container: string;
        title: string;
        buttonContainer: string;
        pageNum: string;
    }
}

interface State {
    quiz?: Bee.Quiz;
    index: number;
    answers: {
        [question: string]: string;
    };
    success: object | null;
    fail: object | null;
}

class Quiz extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            quiz: undefined,
            index: 0,
            answers: {},
            success: null,
            fail: null,
        }
    }

    componentDidMount() {
        this.getQuiz();
    }

    private submit = async () => {
        const { quizId } = this.props.match.params;
        const answers = Object.keys(this.state.answers).map((_, ix) => this.state.answers[ix]);
        const data = await this.props.onSubmit({ quizId, answers });
        if (data && data.status === 200) {
            this.setState({ success: data });
        } else if (data) {
            this.setState({ fail: data });
        }
    }

    private next = () => {
        window.scrollTo(0, 0);
        this.setState({ index: this.state.index + 1 });
    };

    private previous = () => {
        window.scrollTo(0, 0);
        this.setState({ index: this.state.index - 1 });
    };


    private getQuiz = async () => {
        const participate = await this.props.getParticipate({
            quizId: this.props.match.params.quizId,
            username: getUserData().username,
        });
        if (!participate || participate.count > 0) {
            return;
        }
        const rep = await this.props.getQuiz(this.props.match.params.quizId);
        if (rep) {
            this.setState({ quiz: rep });
        }
    }

    private setAnswer = (index: number, answer: string) => {
        const answers = { ...this.state.answers };
        answers[index] = answer;
        this.setState({ answers });
    }

    private onDialogClose = () => {
        this.props.history.push(`${'/quiz'}${this.props.location.hash}`)
    }

  	render() {
        const { index } = this.state;
        const { classes } = this.props;

        const quiz = this.state.quiz;

        if (!quiz) {
            return <Typography variant="h4" align="center">QUIZ NOT FOUND</Typography>
        }

        const question = quiz.questions[index];
        const totalQuestions = quiz.questions.length;

        const backBtnDisabled = index === 0;
        const nextBtnDisabled = this.state.answers[index] === undefined;
        const showSubmitBtn = index === totalQuestions - 1;
        const submitBtnDisabled = this.state.answers[totalQuestions - 1] === undefined;

        return (
            <div className={classes.container}>
                <PageTitle title={quiz.title} />
                <QuizQuestion
                    id={index}
                    key={question.url}
                    question={question}
                    selectedAnswer={this.state.answers[index]}
                    handleAnswerSelect={this.setAnswer}
                />
                
                <div className={classes.buttonContainer}>
                    <Button
                        variant="contained"
                        onClick={this.previous}
                        disabled={backBtnDisabled}
                    >
                        Back
                    </Button>
                    <Typography className={classes.pageNum} variant="caption">{index + 1} / {totalQuestions}</Typography>
                    {!showSubmitBtn ?
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.next}
                            disabled={nextBtnDisabled}
                        >
                            Next
                        </Button>
                    :
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={submitBtnDisabled}
                            onClick={this.submit}
                        >
                            Submit
                        </Button>
                    }
                </div>
                <SuccessDialog
                    open={Boolean(this.state.success)}
                    onClose={this.onDialogClose}
                    message={'Your answers have been submitted.'}
                />
                <FailDialog
                    open={Boolean(this.state.fail)}
                    onClose={this.onDialogClose}
                    message={'Something went wrong while submitting your answers.'}
                />
            </div>
        );
	}
}

export default withStyles(jss)(Quiz);



// WEBPACK FOOTER //
// ./src/components/Quiz/Quiz.tsx